import { Container, Grid, Stack } from '@mui/material';
import { useReducer, useState, useEffect, createRef } from 'react';
import EirInformation from '../eir-information/EirInformation';
import DeviceContext, { defaultState, reducer } from './Device.context';
import DeviceBrandCarousel from './DeviceBrandCarousel';
import EirDeviceCardContainer from './EirDeviceCardContainer';
import PriceMenu from './PriceMenu';
import styles from './styles';

const EirDeviceContainer = ({ devices, brands, loading, cmsData, isHandset, isPrepayHandset }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);
  const [filteredDevices, setFilteredDevices] = useState([]);
  const [sortType, setSortType] = useState('default');
  const [selectedBrandName, setSelectedBrandName] = useState('');
  const scrollDiv = createRef();

  const sortByPrice = type => {
    setSortType(type);
  };
  useEffect(() => {
    // window.scrollTo(0, 0);
    scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
    const sortedDevice = [];
    if (
      selectedBrandName !== 'All Brands'
        ? devices
            .filter(device => device.manufacturer === selectedBrandName)
            .map(dev => sortedDevice.push(dev))
        : setFilteredDevices([])
    )
      setFilteredDevices(sortedDevice);
  }, [devices]);

  const filterBrand = brand => {
    // to call an api for filtering with brand.
    const sortedDevice = [];
    setSelectedBrandName(brand);
    if (
      brand !== 'All Brands'
        ? devices.filter(device => device.manufacturer === brand).map(dev => sortedDevice.push(dev))
        : setFilteredDevices([])
    )
      setFilteredDevices(sortedDevice);
  };
  return (
    <DeviceContext.Provider value={{ state, dispatch, styles }}>
      <Stack sx={{ pb: 7.5, m: 0 }}>
        <Container maxWidth='lg'>
          <Grid container ref={scrollDiv}>
            {!isPrepayHandset && (
              <Grid item xs={12}>
                <EirInformation
                  title={cmsData?.attributes?.EirInformation_Phones?.title}
                  textAlign={cmsData?.attributes?.EirInformation_Phones?.textAlign}
                  description={cmsData?.attributes?.EirInformation_Phones?.description}
                  style={{ description: { mb: 4 } }}
                  useH1={isHandset && cmsData?.attributes?.EirInformation_Phones?.useH1}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <DeviceBrandCarousel
                loading={loading}
                brands={brands}
                filterBrand={filterBrand}
                cmsData={cmsData}
              />
            </Grid>
            <Grid item xs={12}>
              <PriceMenu sortByPrice={sortByPrice} />
              <EirDeviceCardContainer
                loading={loading}
                devices={filteredDevices.length ? filteredDevices : devices}
                sortType={sortType}
                isPrepayHandset={isPrepayHandset}
              />
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </DeviceContext.Provider>
  );
};

export default EirDeviceContainer;
